
import { UnitedOne as utils } from '../../Content/Utils';
import { UnitedOne as services } from '../../Content/Services';



export namespace WebmasterTools {

    import Utils = utils.Utils;
    import Services = services.Services;
    import DialogViewModelBase = utils.DialogViewModelBase;


    export class AlertDialogViewModel extends DialogViewModelBase {

        constructor(public message: string, title: string = '') {
            super('alert-dialog-template', 'Hinweis');

            if (!Utils.stringIsNullOrWhiteSpace(title))
            {
                this.dialogTitle(title);
            }
        }
    }

    export class ConfirmDialogViewModel extends DialogViewModelBase {

        constructor(public message: string, public callback: (result: boolean) => void, title: string = '') {
            super('confirm-dialog-template', 'Bestätigung erforderlich');

            if (!Utils.stringIsNullOrWhiteSpace(title)) {
                this.dialogTitle(title);
            }
        }
        
        public submit() {
            this.callback(true);
            super.close();
        }

        public abort() {
            this.callback(false);
            super.close();
        }

        public close() {
            this.callback(false);
            super.close();
        }
    }

    export class ConfirmWithBusyDialogViewModel extends DialogViewModelBase {

        public isFinished: boolean = false;
        private isClosedLocal: boolean = false;
        public callback: (result: boolean) => void;

        public isBusy: KnockoutObservable<boolean> = ko.observable(false);

        constructor(public message: string, title: string = '') {
            super('confirm-with-busy-dialog-template', 'Bestätigung erforderlich');

            if (!Utils.stringIsNullOrWhiteSpace(title)) {
                this.dialogTitle(title);
            }
        }

        public submit() {
            this.isBusy(true);
            this.isFinished = true;

            window.setTimeout(() => this.callback(true), 10);
            

        }


        public abort() {
          
            if (!this.isFinished)
            {
                this.isFinished = true;
                this.callback(false);
                super.close();
            }
        }

        public close() {
           
            if (!this.isFinished) {
                this.isFinished = true;
                this.callback(false);
                
            }

            if (!this.isClosedLocal) {
                super.close();
                this.isClosedLocal = true;
            }
            
        }
    }


    export class PromptDialogViewModel extends DialogViewModelBase {

        public insertValue: KnockoutObservable<string> = ko.observable('');

        constructor(public message: string, public callback: (result: string) => void, title: string = '', defaultValue: string = '') {
            super('prompt-dialog-template', 'Bestätigung erforderlich');

            if (!Utils.stringIsNullOrWhiteSpace(title)) {
                this.dialogTitle(title);
            }

            if (!Utils.stringIsNullOrWhiteSpace(defaultValue)) {
                this.insertValue(defaultValue);
            }
        }

        public submit() {
            this.callback(this.insertValue());
            super.close();
        }

        public abort() {
            this.callback(null);
            super.close();
        }

        public close() {
            this.callback(null);
            super.close();
        }
    }


    var dialogService = Services.getInstance().dialogs;
    dialogService.alertHandler = (message, title) => (new AlertDialogViewModel(message, title)).show();
    dialogService.confirmHandler = (message, callback, title) => (new ConfirmDialogViewModel(message, callback, title)).show();
    dialogService.confirmWithBusyHandler = (message, callback, title) => {
        var dialog = new ConfirmWithBusyDialogViewModel(message, title);
        dialog.callback = result => {
            callback(result, dialog);
        };
        dialog.show();
        console.log('here');
    }
    dialogService.promptHandler = (message, callback, title, defaultValue) => (new PromptDialogViewModel(message, callback, title, defaultValue)).show();
    
}




